import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'li-components/lib/Field/Text'
import TextArea from 'li-components/lib/Field/TextArea'
import Select from 'li-components/lib/Field/Select'
import Button from 'li-components/lib/next/Button'
import HeaderButton from 'li-components/lib/HeaderButton'
import SvgIcon from 'li-components/lib/SvgIcon'
import Spinner from 'li-components/lib/Spinner'
import vars from 'li-components/lib/styles'

import { tourName } from '../../util'
import Attachments from './Attachments'
import { SecondaryPage } from './styled'
import Dropzone from './Dropzone'

const DropzoneContainer = styled.div`
  > div {
    position: fixed;
    top: 70px;
    left: calc(100% - 350px);
    width: 330px;
    height: calc(100vh - 220px);
    margin: 1rem;
    border: 3px dashed ${vars.brandPrimary};
  }
`

export default class Contact extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    uploadAttachment: PropTypes.func.isRequired,
    uploading: PropTypes.bool.isRequired,
    uploads: PropTypes.array.isRequired,
    removeUpload: PropTypes.func.isRequired,
    requestPending: PropTypes.bool.isRequired,
  }

  static ticketForms = [
    { id: 360000016334, value: 'Data Inquiry' },
    { id: 360000015153, value: 'General Feedback' },
    { id: 360000016594, value: "I don't see my products" },
    { id: 360000016394, value: 'Feature/Other Request' },
    { id: 360000016354, value: 'Technical Issue' },
  ]

  static priorities = ['Low', 'Normal', 'High', 'Urgent']

  static validate(form) {
    return ['subject', 'description', 'issueType'].reduce((errors, key) => {
      if (!(form[key] || '').trim()) {
        errors[key] = true
      }

      return errors
    }, {})
  }

  static errorRequiredText = 'This field is required'

  static initialState = {
    form: {
      subject: '',
      description: '',
      upcs: '',
      issueType: Contact.ticketForms[1].value,
      priority: 'Normal',
    },
    errors: {},
  }

  state = { ...Contact.initialState }

  onSubmit = async e => {
    e.preventDefault()
    const errors = Contact.validate(this.state.form)

    if (Object.keys(errors).length) {
      this.setState({ errors })
    } else {
      const { onCancel, onSubmit } = this.props
      const equalsValue = entry => entry.value === this.state.form.issueType
      const issueType = Contact.ticketForms.find(equalsValue).id
      const request = { ...this.state.form, issueType }

      const succeeded = await onSubmit(request)

      if (succeeded) {
        this.reset()
        onCancel()
      }
    }
  }

  reset() {
    this.setState(Contact.initialState)
  }

  onChangeFor = key => e => {
    const { value } = e.currentTarget
    const errors = { ...this.state.errors }

    if (errors[key] && value) {
      delete errors[key]
    }

    this.setState({
      form: {
        ...this.state.form,
        [key]: value,
      },
      errors,
    })
  }

  errorFor(key) {
    return this.state.errors[key] ? Contact.errorRequiredText : ''
  }

  onClickAddFile = () => {
    this.fileInput.click()
  }

  onChangeFileInput = e => {
    this.props.uploadAttachment(e.currentTarget.files[0])
  }

  render() {
    const {
      onCancel,
      uploadAttachment,
      uploads,
      removeUpload,
      uploading,
      requestPending,
    } = this.props

    return (
      <SecondaryPage>
        <header onClick={onCancel}>
          <HeaderButton>
            <SvgIcon name="left-2" />
          </HeaderButton>
          <h3>Contact</h3>
        </header>
        <main>
          {requestPending ? (
            <Spinner isShowing />
          ) : (
            <form onSubmit={this.onSubmit}>
              <Text
                label="Subject"
                value={this.state.form.subject}
                onChange={this.onChangeFor('subject')}
                cols={12}
                error={this.errorFor('subject')}
              />
              <Select
                label="Issue Type"
                placeholder="Select an issue type"
                value={this.state.form.issueType}
                cols={12}
                onChange={this.onChangeFor('issueType')}
              >
                {Contact.ticketForms.map(form => (
                  <option key={form.id} value={form.value}>
                    {form.value}
                  </option>
                ))}
              </Select>
              <TextArea
                label="Description"
                helpHint="Please enter the details of your request. A member of our support staff will respond as soon as possible."
                value={this.state.form.description}
                onChange={this.onChangeFor('description')}
                cols={12}
                error={this.errorFor('description')}
              />
              <div style={{ marginBottom: '3rem' }} />
              <Select
                label="Priority"
                value={this.state.form.priority}
                cols={12}
                onChange={this.onChangeFor('priority')}
              >
                {Contact.priorities.map(priority => (
                  <option key={priority} value={priority}>
                    {priority}
                  </option>
                ))}
              </Select>
              <Text
                label="UPC(s)"
                helpHint="If a UPC is not available, please provide another unique product identifier"
                value={this.state.form.upcs}
                onChange={this.onChangeFor('upcs')}
                cols={12}
              />
              <Attachments
                fieldProps={{ cols: 12 }}
                files={uploads}
                loading={uploading}
                onRemoveFile={removeUpload}
                onClickAddFile={this.onClickAddFile}
              />
              <input
                type="file"
                style={{ display: 'none' }}
                onChange={this.onChangeFileInput}
                ref={node => {
                  this.fileInput = node
                }}
              />
              <DropzoneContainer>
                <Dropzone onDropFile={uploadAttachment} />
              </DropzoneContainer>
            </form>
          )}
        </main>
        <footer>
          <Button block onClick={onCancel} disabled={uploading}>
            Cancel
          </Button>
          <div style={{ marginBottom: '1rem' }} />
          <Button
            block
            kind="primary"
            onClick={this.onSubmit}
            disabled={uploading}
            data-tour={tourName('help-contact-submit')}
          >
            Send
          </Button>
        </footer>
      </SecondaryPage>
    )
  }
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/Contact.js